
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/gluten-free",
      function () {
        return require("private-next-pages/gluten-free.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/gluten-free"])
      });
    }
  